import { all } from 'redux-saga/effects';

import listaPaisesSaga from './listaPaises/saga';

export default all([listaPaisesSaga]);
